import Cookies from 'js-cookie'

const state = {
  size: '',
}

const mutations = {
  TOGGLE_SIDEBAR: (state) => {},
}

const actions = {
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
